import { Injectable } from '@angular/core';
import { StudentMaster } from '../model/StudentMaster.model';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { SessionClient } from '../configration/sessionclient.storage';
import { User } from '../model/User.model';
import { CourseMaster } from '../model/CourseMaster.model';
import { MessageService } from 'primeng/api';
import { LectureMaster } from '../model/LectureMaster.model';
import { EnrollCourseMaster } from '../model/EnrollCourseMaster.model';
import { StudentLectureMaster } from '../model/StudentLectureMaster.model';
import { TrainerMaster } from '../model/TrainerMaster.model';
import { ReceiptMaster } from '../model/ReceiptMaster.model';



@Injectable({
  providedIn: 'root'
})
export class AuthService {
  StudentMaster:StudentMaster = new StudentMaster();
  studentMaster:StudentMaster=new StudentMaster();
  courseMaster:CourseMaster = new CourseMaster();
  trainerMaster:TrainerMaster=new TrainerMaster();
  recieptMaster:ReceiptMaster=new ReceiptMaster();
  courseList:CourseMaster[]=[];
  studentLectureMaster:StudentLectureMaster=new StudentLectureMaster();
  messageService: MessageService
  user:User= new User();
  constructor(public http:HttpClient,public sessionClient:SessionClient) { }
  attemptAuth(user): Observable<any> {
    return this.http.post<any>(environment.apiUrl+'token/generate-token-student', user);
  }
  
  getUserDetailsByUsername(user:User): Observable<any> {
    
    return this.http.post<any>(environment.apiUrl+'user/getUserDetailsByUsername', user);
  }
  setUserSession(studentMaster:StudentMaster){
    
    this.sessionClient.saveSession("studentSession",JSON.stringify(studentMaster));
    // this.user=JSON.parse(localStorage.getItem("userSession"));
  }
  getUserSession(){
    
    this.studentMaster=JSON.parse(localStorage.getItem("studentSession"));
    return this.studentMaster;
  }

  setTrainerSession(trainerMaster:TrainerMaster){
    
    this.sessionClient.saveSession("trainerSession",JSON.stringify(trainerMaster));
    // this.user=JSON.parse(localStorage.getItem("userSession"));
  }
  getTrainerSession(){
    
    this.trainerMaster=JSON.parse(localStorage.getItem("trainerSession"));
    return this.trainerMaster;
  }

  setRecieptSession(recieptMaster:any){
    
    this.sessionClient.saveSession("recieptSession",JSON.stringify(recieptMaster));
    // this.user=JSON.parse(localStorage.getItem("userSession"));
  }
  getRecieptSession(){
    
    this.recieptMaster=JSON.parse(localStorage.getItem("recieptSession"));
    return this.recieptMaster;
  }


  sendOtpToUser(user:User): Observable<any>{
    
    return this.http.post<any>(environment.apiUrl+'user/sendOTPAPI', user);
  }
  forgetStudentPassword(user:User): Observable<any>{
    
    return this.http.post<any>(environment.apiUrl+'user/forgetPassword', user);
  }
  getCourseMasterOptimizeList(courseMaster:CourseMaster): Observable<any>{
    
    return this.http.post<any>(environment.apiUrl+'course/getCourseMasterOptimizeList', courseMaster);
  }
  getCourseMasterById(courseMaster:CourseMaster): Observable<any>{
    
    return this.http.post<any>(environment.apiUrl+'course/getCourseMasterById', courseMaster);
  }
  setcourseMasterSession(courseMaster:CourseMaster){
    this.courseMaster=courseMaster;
    this.sessionClient.saveSession("courseMasterSession",JSON.stringify(this.courseMaster));
  }

  getcourseMasterSession(){
  
    this.courseMaster=JSON.parse(localStorage.getItem("courseMasterSession"));
 // }
  return this.courseMaster;
}

setcourseListSession(courseList:CourseMaster[]){
  this.courseList=courseList;
  this.sessionClient.saveSession("courseListSession",JSON.stringify(this.courseList));
}

getcourseListSession(){

  this.courseList=JSON.parse(localStorage.getItem("courseListSession"));
// }
return this.courseList;
}



  showMessage(severityData: string, summaryData: string, detailData: string) {
    this.messageService.add({ severity: severityData, summary: summaryData, detail: detailData });
  }




   
    setlectureMasterSession(studentLectureMaster:StudentLectureMaster){
      this.studentLectureMaster=studentLectureMaster;
      this.sessionClient.saveSession("studentLectureMasterSession",JSON.stringify(this.studentLectureMaster));
    }

    getlectureMasterSession(){
  
      this.studentLectureMaster=JSON.parse(localStorage.getItem("studentLectureMasterSession"));
   // }
    return this.studentLectureMaster;
  }




    checkDuplicateEmailAndMobileNo(user:User): Observable<any>{
    
      return this.http.post<any>(environment.apiUrl+'user/checkDuplicateEmailAndMobileNo', user);
    }
    changePassword(user:User): Observable<any> {
    
      return this.http.put<any>(environment.apiUrl+'user/changePassword', user);
    }

  
    setEnrollCourseMasterSession(enrollCourseMaster:EnrollCourseMaster){
      this.sessionClient.saveSession("enrollCourseMasterSession",JSON.stringify(enrollCourseMaster));
    }
  
    getEnrollCourseMasterSession(){
      return JSON.parse(localStorage.getItem("enrollCourseMasterSession"));;
    }



}
